import { Box, Button, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import SpaOutlinedIcon from "@mui/icons-material/SpaOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import React from "react";
import { Link } from "react-router-dom";

const highlights = [
  {
    icon: <SpaOutlinedIcon fontSize="small" />,
    title: "100% herbal",
    text: "Ayurvedic formulations",
  },
  {
    icon: <SupportAgentOutlinedIcon fontSize="small" />,
    title: "Personal guidance",
    text: "Help choosing a product",
  },
  {
    icon: <VerifiedOutlinedIcon fontSize="small" />,
    title: "Trusted quality",
    text: "Reliable health solutions",
  },
];

const CtaBanner = () => {
  return (
    <Box className="wellness-cta">
      <Box className="wellness-cta-inner">
        <Box className="wellness-cta-copy">
          <Typography component="p" className="wellness-cta-eyebrow">
            Start your wellness routine
          </Typography>
          <Typography component="h2" className="wellness-cta-title">
            Find the herbal product that fits you
          </Typography>
          <Typography component="p" className="wellness-cta-text">
            Shop our collections or message us on WhatsApp if you need help
            choosing the right Ayurvedic solution.
          </Typography>
          <Box className="wellness-cta-actions">
            <Button
              component={Link}
              to="/collections"
              variant="contained"
              startIcon={<ShoppingBagOutlinedIcon />}
              className="wellness-cta-btn wellness-cta-btn-primary"
            >
              Shop collections
            </Button>
            <Button
              component="a"
              href="https://api.whatsapp.com/send/?phone=919411174186"
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              startIcon={<WhatsAppIcon />}
              className="wellness-cta-btn wellness-cta-btn-ghost"
            >
              Chat on WhatsApp
            </Button>
          </Box>
        </Box>
        <Box className="wellness-cta-panel">
          {highlights.map((item) => (
            <Box className="wellness-cta-point" key={item.title}>
              <Box className="wellness-cta-point-icon">{item.icon}</Box>
              <Box>
                <Typography component="p" className="wellness-cta-point-title">
                  {item.title}
                </Typography>
                <Typography component="p" className="wellness-cta-point-text">
                  {item.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CtaBanner;
